import pultClasses from './styles.module.sass';
import Preview from '../Preview/Preview';
import pultPreview from './preview.png';
import { ReactComponent as PultBackButton } from './svg/back-button.svg';
import { ReactComponent as PultTogglePlay } from './svg/toggle-play.svg';
import { ReactComponent as PultTogglePause } from './svg/toggle-pause.svg';
import { ReactComponent as PultPlay } from './svg/play.svg';
import { ReactComponent as PultSpeed } from './svg/speed.svg';
import { ReactComponent as PultFullscreenEnter } from './svg/fullscreen-enter.svg';
import { ReactComponent as PultFullscreenExit } from './svg/fullscreen-exit.svg';
import { ReactComponent as PultVolume } from './svg/volume.svg';
import { ReactComponent as PultVolumeMuted } from './svg/volume-muted.svg';
import { ReactComponent as PultChapters } from './svg/chapters.svg';
import { ReactComponent as PultQuality } from './svg/quality.svg';
import { ReactComponent as PultSubtitles } from './svg/subtitles.svg';

import { getBgColor } from '../../../WithBackgroundColor/WithBackgroundColor';
import { IPlayerSkin } from '../types';

// #2
export const pultSkin: IPlayerSkin = {
  key: 'pult',
  label: 'Pult',
  classes: pultClasses,
  component: Preview,
  preview: pultPreview,
  handles: true,
  handleValue: false,
  tips: false,
  icons: {
    backButton: PultBackButton,
    togglePlay: PultTogglePlay,
    togglePause: PultTogglePause,
    play: PultPlay,
    speed: PultSpeed,
    fullscreenEnter: PultFullscreenEnter,
    fullscreenExit: PultFullscreenExit,
    quality: PultQuality,
    volume: PultVolume,
    volumeMuted: PultVolumeMuted,
    chapters: PultChapters,
    subtitles: PultSubtitles,
  },
  bgColors: {
    controls__root: getBgColor,
    controls__popover: getBgColor,
    progressBar__handle: getBgColor,
    progressBar__previews: getBgColor,
  },
  colors: {
    backButton: getBgColor,
    controls__popoverTip: getBgColor,
  },
  approximateBarHeight: 38,
};
